import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/branch.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleBranchCreatedEvent, ActivityEventTrackMode } from './Types'
import { Link } from 'react-router-dom'
import { stopPropagation } from 'utils'

interface Props extends ActivityEventPosition {
  event: ArticleBranchCreatedEvent
}

const ArticleBranchCreated = ({ event, ...props }: Props) => {
  const {
    user,
    article,
    data: { branch, base_branch, status_name, status_color },
  } = event
  const isBaseBranch = base_branch.key === article.key

  const content = isBaseBranch ? (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> created a linked copy:{' '}
      <Link to={branch.url} onClick={stopPropagation}>
        {branch.title}
      </Link>
    </>
  ) : (
    <>
      <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> created this linked copy from:{' '}
      <Link to={base_branch.url} onClick={stopPropagation}>
        {base_branch.title}
      </Link>
    </>
  )

  return (
    <BaseActivityEvent
      {...props}
      status={!isBaseBranch && status_name && status_color ? { name: status_name, color: status_color } : undefined}
      trackMode={isBaseBranch ? ActivityEventTrackMode.Branch : undefined}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={content}
    />
  )
}

export { ArticleBranchCreated }
